<template>
  <div id="roomList">
    <!-- nav -->
    <navbar></navbar>
    <div class="container mt-4">
      <!-- ゲームのリスト -->
      <h4>ゲーム一覧</h4>
      <amplify-connect :query="listGameQuery" @error="onError">
        <template slot-scope="{ loading, data, errors }">
          <div v-if="loading">Loading...</div>

          <div v-else-if="errors.length > 0">
            <div v-for="(error, index) in errors" v-bind:key="index">{{ error.message }}</div>
          </div>

          <div v-else-if="data">
            <b-table borderless small responsive :items="data.listGames.items" :fields="gameFields">
              <template v-slot:cell(title)="data">
                <router-link :to="'/game/' + data.item.id">
                  {{
                  data.item.title
                  }}
                </router-link>
              </template>
            </b-table>
          </div>
        </template>
      </amplify-connect>
      <!-- ルームのリスト  -->
      <h4>ルーム一覧</h4>
      <amplify-connect :query="listRoomQuery" @error="onError">
        <template slot-scope="{ loading, data, errors }">
          <div v-if="loading">Loading...</div>

          <div v-else-if="errors.length > 0">
            <div v-for="(error, index) in errors" v-bind:key="index">{{ error.message }}</div>
          </div>

          <div v-else-if="data">
            <b-table borderless small :items="data.listRooms.items" :fields="roomFields">
              <template v-slot:cell(name)="data">
                <router-link :to="'/room/' + data.item.id">
                  {{
                  data.item.name
                  }}
                </router-link>
              </template>
              <template v-slot:cell(owner)="data">
                <span>{{getOwnerName(data)}}</span>
              </template>
              <template v-slot:cell(gameTitle)="data">
                <router-link :to="'/game/' + data.item.gameId">
                  {{
                  data.item.gameTitle
                  }}
                </router-link>
              </template>
              <template v-slot:cell(guests.items)="data">
                <span>{{data.item.guests.items.reduce((str , gue)=> str + "・" + gue.name, "")}}</span>
              </template>
              <template v-slot:cell(id)="data">
                <router-link :to=" '/room/' + data.item.id">
                  {{
                  'https://master.d1pjjmf6on1sf7.amplifyapp.com' + '/room/' + data.item.id
                  }}
                </router-link>
              </template>
            </b-table>
          </div>
        </template>
      </amplify-connect>
    </div>
  </div>
</template>

<script>
import { listGames, listRooms } from "../graphql2/queries.js";
import Navbar from "@/components/Navbar.vue";

export default {
  components: { Navbar },
  data() {
    return {
      gameFields: [
        { key: "title", label: "ゲーム名" },
        { key: "description", label: "ゲームの説明" }
      ],

      roomFields: [
        { key: "name", label: "ルーム名" },
        { key: "owner", label: "管理人" },
        { key: "gameTitle", label: "使用ゲーム名" },
        { key: "guests.items", label: "参加者" },
        { key: "id", label: "アドレス" }
      ]
    };
  },
  methods: {
    // モーダルでエラー表示
    onError(errorObj) {
      let errorMessage = "";
      console.error(errorObj);

      if (errorObj.errors != null) {
        errorMessage = errorObj.errors.reduce(
          (addStr, obj) => addStr + "\n" + obj.message,
          ""
        );
      } else {
        errorMessage = errorObj.message;
      }

      this.$bvModal.msgBoxOk(errorMessage).catch(err => {
        console.log(err);
      });
    }
  },
  computed: {
    listGameQuery() {
      return this.$Amplify.graphqlOperation(listGames, { limit: 1000 });
    },
    listRoomQuery() {
      return this.$Amplify.graphqlOperation(listRooms, { limit: 1000 });
    },
    getOwnerName() {
      return data => {
        let guest = data.item.guests.items.find(
          gue => gue.userName === data.item.owner
        );
        if (guest != null) {
          return guest.name;
        } else {
          return "";
        }
      };
    }
  }
};
</script>
